import React, { useContext, useEffect, useReducer, useState } from "react";
import { Divider, Grid, Stack } from "@mui/material";
import { Box } from "@mui/system";
// import MUIDataTable from 'mui-datatables'
// import { ContainedButton } from '../../ui_components/MyButtons'
// import { useEffect } from 'react'
import { MyDropdown } from "../../components/900/MyDropdown";
// import api from '../../../api/mainAPI'
// import { MyTab } from '../../../ui_components/MyTabs'
import {
  MyBarChartCard,
  MyBarChartCard2,
  MyPieChartCard,
  MyPieChartCard2,
  MyStaffLoadCard,
  MyTextCard,
} from "../../components/900/MyCards";
import reducer from "../../components/900/contexts/reducers/reducer";
import { initialState } from "../../components/900/contexts/initialStates/initialState";
// import api from "../../api/PrivateApi";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import StaffReportContext from "../../context/600/StaffReportContextProvider";

const Dashboard = () => {
  const [reportState, reportDispatch] = useReducer(reducer, initialState);
  const [staffReportState, staffReportDispatch] = useContext(StaffReportContext)
  // useEffect(() => {
  //   if(reportState.selectedTerm === '') {
  //     api.get('batchReport')
  //     .then(res => {
  //       console.log(res.data)
  //       reportDispatch({type: 'load', payload: res.data})
  //     })
  //     .catch(err => console.log('Error:', err))
  //   } else {
  //       api.get("batchReport/filter",{
  //         params:{
  //           semester: reportState.selectedSemester,
  //           term: reportState.selectedTerm,
  //           department: 1,
  //         }
  //       })
  //       .then(res => {
  //         console.log(res.data)
  //         console.log(res.data.batches)
  //         reportDispatch({type: 'load', payload: res.data})
  //       })
  //       .catch(err => console.log('Error:', err))
  //   }
  // }, [reportState.selectedSemester, reportState.selectedTerm])
  const [data,setData]=useState()
  const api = useAxiosPrivate()
  useEffect(()=>{
        let isMounted=true;
        const controller=new AbortController();
        const getData=async ()=>{
          try{
            const response=await api.get(`request/dashboard`,{
              signal:controller.signal
            })
            isMounted &&  setData(response.data)
          }
          catch(err){
            console.error(err)
          }
        }
        getData();
        return ()=>{
          isMounted=false;
          controller.abort()
        }
          },[])
    useEffect(()=> {
      api.get("/reports/staffLoad").then(res=> {
        console.log("ReportDispatch called")
        staffReportDispatch({type:'staffLoads', payload:{
          staffLoad: res.data.staffLoadArray
        }})
      })
    }, [])

  const handleSemesterFilter = (e) => {
    reportDispatch({
      type: "changeSemester",
      payload: { selectedSemester: e.target.value },
    });
  };
  const handleTermFilter = (e) => {
    reportDispatch({
      type: "changeTerm",
      payload: { selectedTerm: e.target.value },
    });
  };

  return (
    <Box sx={{ m: 2 }}>
      {/* Filters */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "right", sm: "center" }}
        justifyContent="flex-end"
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{
          m: 1,
          md: {
            backgroundColor: "#ff0",
          },
        }}>
        {/* Semester filter */}
        {/* <MyDropdown inputs={{
            name: 'Semester', 
            defaultValue: reportState.selectedSemester,
            handleChange: handleSemesterFilter,
            id: 'Semester_filter', 
            values: [1, 2],
            disable: false,
          }} /> */}

        {/* Term Filter */}
        {/* <MyDropdown inputs={{
            name: 'Term', 
            defaultValue: `${reportState.selectedTerm}`,
            handleChange: handleTermFilter,
            id: 'Term_filter', 
            values: reportState.terms,
            disable: false,
          }} /> */}
      </Stack>
      {/* Visualize */}
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ m: 1, mb: 2 }}>
        {/* Load Distribution */}
        <MyBarChartCard
          inputs={{
            title: "Total Staff",
            option1: "Full Time",
            value1: data?.fullStaff || 0,
            option2: "Part Time",
            value2: data?.partStaff || 0,
          }}
        />
        {/* <MyPieChartCard inputs={{
                mydata: {
                    name: "Staff Type",
                option1: "Full Time",
                option2: "Part Time",
                value1: reportState.fullTime,
                value2: reportState.partTime,
            },
        }}/> */}
        <MyTextCard
          inputs={{
            value: data?.students || 0,
            title: "Students Enrolled",
            size: 3,
          }}
        />
        <MyTextCard
          inputs={{
            value: data?.groups || 0,
            title: "Groups Formulated",
            size: 3,
          }}
        />
        <MyPieChartCard2
          inputs={{
            mydata: {
              name: "Load",
              option1: "Overload",
              option2: "Underload",
              option3: "Neutral",
              value1: reportState.overload,
              value2: reportState.underload,
              value3: reportState.neutral,
            },
          }}
        />
        <MyStaffLoadCard
          inputs={{
            mydata: staffReportState.staffLoad,
          }}
        />
        {/* <MyBarChartCard inputs={{
          title: "Admission",
          option1: 'Regular',
          value1: reportState.regular,
          option2: 'Extension',
          value2: reportState.extension
        }}/>
        <MyBarChartCard inputs={{
            title: 'Program',
            option1: 'Undergraduate',
            value1: reportState.undergraduate,
            option2: 'Postgraduate',
            value2: reportState.postgraduate
        }} /> */}
      </Grid>

      {/* <MUIDataTable 
        title={reportState.tableHeader}
        data={reportState.tableData} 
        columns={reportState.tableColumn}
        options={options}
    /> */}

      {/* Put this component in the mui table */}
      {/* <StaffDetails /> */}
    </Box>
  );
};

export default Dashboard;
